module.exports = __webpack_public_path__ + "img/fi-rr-filter.80ebbf97.svg";